import React from 'react';
import styled from 'styled-components';

const CardTitleS = styled.div`
  font-size: 24px;
  font-weight: 700;
  margin: ${({ margin }) => margin || '0'};
`;

export function CardTitle(props) {
  return <CardTitleS {...props} />;
}
